"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterValue = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@apitable/core");
const helper_1 = require("./helper");
const filter_checkbox_1 = require("./filter_checkbox");
const filter_number_1 = require("./filter_number");
const filter_text_1 = require("./filter_text");
const filter_rating_1 = require("./filter_rating");
const filter_select_1 = require("./filter_select");
const filter_date_1 = require("./filter_date/filter_date");
const FilterValue = props => {
    const { onChange, value, field: _field, operator } = props;
    let field = _field;
    const editorType = (0, helper_1.getFieldEditorType)(field);
    const { hasError, isComputed } = core_1.Field.bindModel(field);
    if (hasError)
        return react_1.default.createElement(react_1.default.Fragment, null);
    if (isComputed) {
        if (field.type === core_1.FieldType.LookUp) {
            const expr = core_1.Field.bindModel(field).getExpression();
            if (!expr) {
                const entityField = core_1.Field.bindModel(field).getLookUpEntityField();
                if (entityField) {
                    field = entityField;
                }
            }
        }
        const fakeField = (0, helper_1.getFieldByBasicType)(field);
        if (fakeField)
            field = fakeField;
    }
    function Editor(editorType) {
        switch (editorType) {
            case helper_1.EditorType.Text:
                return ((react_1.default.createElement(filter_text_1.FilterText, { value: value, field: field, onChange: onChange })));
            case helper_1.EditorType.Boolean:
                return (react_1.default.createElement(filter_checkbox_1.FilterCheckbox, { value: value, field: field, onChange: onChange }));
            case helper_1.EditorType.Number:
            case helper_1.EditorType.Currency:
            case helper_1.EditorType.Percent:
                return ((react_1.default.createElement(filter_number_1.FilterNumber, { field: field, value: value, onChange: onChange })));
            case helper_1.EditorType.None:
                return react_1.default.createElement("div", null);
            case helper_1.EditorType.Rating:
                return ((react_1.default.createElement(filter_rating_1.FilterRating, { field: field, value: value, onChange: onChange })));
            case helper_1.EditorType.Options: {
                return (react_1.default.createElement(filter_select_1.FilterSelect, { field: field, value: value, onChange: onChange, operator: operator }));
            }
            case helper_1.EditorType.DateTime: {
                return (react_1.default.createElement(filter_date_1.FilterDate, { field: field, value: value, onChange: onChange, operator: operator }));
            }
            default:
                console.error('%s is not a never type', field.type);
                return react_1.default.createElement("div", null);
        }
    }
    // Determine if a field of this type requires an input box.
    const isDisplay = ![core_1.FOperator.IsEmpty, core_1.FOperator.IsNotEmpty].includes(operator);
    return (react_1.default.createElement("div", null, isDisplay && Editor(editorType)));
};
exports.FilterValue = FilterValue;
